import * as React from 'react'

import { AsyncStatus } from '@ally/transmitigator'
import { LoginHeading } from '@ally/ally-login'

import { useTransmit } from '../../TransmitContext'
import { BusinessForgotPasswordForm, PersonalForgotPasswordForm } from './Forms'

export const UsernameStep: React.FC<{
  status: AsyncStatus | 'Blocked' | 'Error'
  username?: string
  isResetPassword?: boolean
  error?: string | undefined
}> = ({ status, username = '', isResetPassword, error }) => {
  const { hostServices } = useTransmit()
  const [isAutoBusinessUser, setIsAutoBusinessUser] = React.useState(false)
  const toggleAutoBusinessUser = (): void => {
    setIsAutoBusinessUser(!isAutoBusinessUser)
  }

  React.useEffect(() => {
    hostServices?.analytics.trackPageView({
      eventType: 'pageview',
      pageName: 'AOS:Login:Forgot Password:Username Step',
    })
  }, [])

  const title = isResetPassword ? 'Reset Password' : 'Forgot Password'

  return (
    <>
      <LoginHeading
        title={title}
        data-testid="forgot-password-v2-username-step-heading"
      />

      {isAutoBusinessUser ? (
        <BusinessForgotPasswordForm
          error={error}
          isAutoBusinessUser={isAutoBusinessUser}
          status={status}
          toggle={toggleAutoBusinessUser}
        />
      ) : (
        <PersonalForgotPasswordForm
          error={error}
          isAutoBusinessUser={isAutoBusinessUser}
          isResetPassword={isResetPassword}
          status={status}
          toggle={toggleAutoBusinessUser}
          username={username}
        />
      )}
    </>
  )
}
